import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
::selection {
    color: #fff;
    background-color: #5fcc9c;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    font-family: 'open sans', sans-serif;
    /* color: #251a41; */
    overflow-x: hidden;
}
`
